import React, { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { Button, Input, Textarea, Label, Card, Modal, StatusPill } from "@/components/kit";
import { Plus, Pencil, Trash2, FolderKanban } from "lucide-react";
import { toast } from "sonner";

const empty = { name: "", contractor_name: "", contractor_email: "", address: "", description: "", status: "active" };

export default function Projects() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);

  const load = () => api.get("/projects").then((r) => setItems(r.data)).catch((e) => toast.error(apiErr(e)));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (editId) await api.put(`/projects/${editId}`, form);
      else await api.post("/projects", form);
      toast.success("Projekt sparat");
      setOpen(false); setForm(empty); setEditId(null); load();
    } catch (err) { toast.error(apiErr(err)); }
  };
  const edit = (p) => { setForm({ ...empty, ...p }); setEditId(p.id); setOpen(true); };
  const del = async (id) => { if (!window.confirm("Ta bort projekt?")) return; await api.delete(`/projects/${id}`); load(); };

  return (
    <div className="rise">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <p className="text-xs uppercase tracking-widest text-amber-500">Hantering</p>
          <h1 className="font-display text-3xl font-extrabold text-white">Projekt</h1>
        </div>
        <Button data-testid="add-project-button" onClick={() => { setForm(empty); setEditId(null); setOpen(true); }}>
          <Plus size={16} /> Nytt projekt
        </Button>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {items.map((p) => (
          <Card key={p.id} className="p-5 hover:border-slate-700 transition-colors" data-testid={`project-card-${p.id}`}>
            <div className="mb-3 flex items-start justify-between">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-amber-500/10 text-amber-400">
                <FolderKanban size={18} />
              </div>
              <StatusPill status={p.status} />
            </div>
            <h3 className="font-display text-lg font-bold text-white">{p.name}</h3>
            <p className="mt-0.5 text-sm text-slate-400">{p.contractor_name || "Ingen beställare"}</p>
            {p.address && <p className="mt-2 text-xs text-slate-500">{p.address}</p>}
            <div className="mt-4 flex gap-2">
              <Button variant="outline" className="px-3 py-1.5 text-xs" data-testid={`edit-project-${p.id}`} onClick={() => edit(p)}>
                <Pencil size={13} /> Redigera
              </Button>
              <Button variant="danger" className="px-3 py-1.5 text-xs" data-testid={`delete-project-${p.id}`} onClick={() => del(p.id)}>
                <Trash2 size={13} />
              </Button>
            </div>
          </Card>
        ))}
        {items.length === 0 && <p className="text-slate-500">Inga projekt ännu.</p>}
      </div>

      <Modal open={open} onClose={() => setOpen(false)} title={editId ? "Redigera projekt" : "Nytt projekt"}>
        <form onSubmit={save} className="space-y-4">
          <div><Label>Projektnamn</Label><Input data-testid="project-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Beställare</Label><Input data-testid="project-contractor-input" value={form.contractor_name} onChange={(e) => setForm({ ...form, contractor_name: e.target.value })} /></div>
            <div><Label>Beställarens e-post</Label><Input value={form.contractor_email} onChange={(e) => setForm({ ...form, contractor_email: e.target.value })} /></div>
          </div>
          <div><Label>Adress / plats</Label><Input value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></div>
          <div><Label>Beskrivning</Label><Textarea rows={2} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} /></div>
          <div><Label>Status</Label>
            <select className="w-full rounded-lg bg-slate-950/60 border border-slate-700 px-3.5 py-2.5 text-sm text-slate-100" value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>
              <option value="active">Aktiv</option>
              <option value="closed">Avslutad</option>
            </select>
          </div>
          <Button data-testid="save-project-button" type="submit" className="w-full">Spara</Button>
        </form>
      </Modal>
    </div>
  );
}
